module.exports = __webpack_public_path__ + "static/img/COC2021-12.2652001.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-12.jpg
// module id = KId3
// module chunks = 0